export const WATERFALL_FUND_SUMMARY_COLUMNS = [
  { key: 'entity', label: 'Entity' },
  { key: 'exitProceeds', label: 'Exit Proceeds' },
  { key: 'previousProceeds', label: 'Previous Proceeds' },
  { key: 'investedCapital', label: 'Invested Capital' },
  { key: 'moic', label: 'MOIC' },
  { key: 'irr', label: 'IRR' },
];
